"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeName = void 0;
var AttributeName;
(function (AttributeName) {
    AttributeName["FacilityType"] = "facilityType";
    AttributeName["FacilityAccess"] = "facilityAccess";
    AttributeName["LooseOrSlipperySurface"] = "looseOrSlipperySurface";
    AttributeName["TramOrTrainRails"] = "tramOrTrainRails";
    AttributeName["MajorSurfaceDeformationOrDrainOpening"] = "majorSurfaceDeformationOrDrainOpening";
    AttributeName["FixedObstacleOnFacility"] = "fixedObstacleOnFacility";
    AttributeName["NonFixedObstacleOnFacility"] = "nonFixedObstacleOnFacility";
    AttributeName["LineOfSight"] = "lineOfSight";
    AttributeName["Delineation"] = "delineation";
    AttributeName["LightSegregation"] = "lightSegregation";
    AttributeName["FacilityWidthPerDirection"] = "facilityWidthPerDirection";
    AttributeName["FlowDirection"] = "flowDirection";
    AttributeName["WidthRestriction"] = "widthRestriction";
    AttributeName["Grade"] = "grade";
    AttributeName["Curvature"] = "curvature";
    AttributeName["StreetLighting"] = "streetLighting";
    AttributeName["PedestrianCrossing"] = "pedestrianCrossing";
    AttributeName["IntersectionBicycleFacility"] = "intersectionBicycleFacility";
    AttributeName["IntersectionApproach"] = "intersectionApproach";
    AttributeName["IntersectionOrRoadCrossing"] = "intersectionOrRoadCrossing";
    AttributeName["CrossingFacility"] = "crossingFacility";
    AttributeName["NumberOfLanesAdjacentRoad"] = "numberOfLanesAdjacentRoad";
    AttributeName["NumberOfLanesIntersectingRoad"] = "numberOfLanesIntersectingRoad";
    AttributeName["PropertyAccess"] = "propertyAccess";
    AttributeName["PeakPedestrianFlowAlongOrAcrossFacility"] = "peakPedestrianFlowAlongOrAcrossFacility";
    AttributeName["PeakBicycleAndLVTrafficFlow"] = "peakBicycleAndLVTrafficFlow";
    AttributeName["ObservedProportionOfCargoBikesAndMopeds"] = "observedProportionOfCargoBikesAndMopeds";
    AttributeName["BicycleAndLVSpeedAverage"] = "bicycleAndLVSpeedAverage";
    AttributeName["BicycleAndLVSpeedDifferential"] = "bicycleAndLVSpeedDifferential";
    AttributeName["RoadOperatingSpeed"] = "roadOperatingSpeed";
    AttributeName["RoadAADT"] = "roadAADT";
    AttributeName["HeavyVehicleFlow"] = "heavyVehicleFlow";
    AttributeName["RoadSpeedLimit"] = "roadSpeedLimit";
    AttributeName["AdjacentFeatures0to1mRoadLane"] = "adjacentFeatures0to1m.roadLane";
    AttributeName["AdjacentFeatures0to1mVehicleParking"] = "adjacentFeatures0to1m.vehicleParking";
    AttributeName["AdjacentFeatures0to1mSevereHazard"] = "adjacentFeatures0to1m.severeHazard";
    AttributeName["AdjacentFeatures0to1mObjectOrLevelChange"] = "adjacentFeatures0to1m.objectOrLevelChange";
    AttributeName["AdjacentFeatures0to1mSidewalk"] = "adjacentFeatures0to1m.sidewalk";
    AttributeName["AdjacentFeatures1to3mRoadLane"] = "adjacentFeatures1to3m.roadLane";
    AttributeName["AdjacentFeatures1to3mVehicleParking"] = "adjacentFeatures1to3m.vehicleParking";
    AttributeName["AdjacentFeatures1to3mSevereHazard"] = "adjacentFeatures1to3m.severeHazard";
    AttributeName["AdjacentFeatures1to3mObjectOrLevelChange"] = "adjacentFeatures1to3m.objectOrLevelChange";
    AttributeName["AdjacentFeatures1to3mSidewalk"] = "adjacentFeatures1to3m.sidewalk";
    AttributeName["AreaType"] = "areaType";
    AttributeName["Comment"] = "comment";
})(AttributeName || (exports.AttributeName = AttributeName = {}));
